// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "flowbite/dist/flowbite.turbo.js";
import "trix"
import "@rails/actiontext"
import LocalTime from "local-time";
LocalTime.start();
